import {
  CREATE_RENEWAL_INVOICE,
  CREATE_RENEWAL_INVOICE_ERROR,
  CREATE_RENEWAL_INVOICE_SUCCESS,
  FETCH_RENEWAL_INVOICE_STATUS,
  FETCH_RENEWAL_INVOICE_STATUS_ERROR,
  FETCH_RENEWAL_INVOICE_STATUS_SUCCESS,
} from "./constants";
import {
  ActionTypes,
  IRenewalInvoiceCreatedPayload,
  IRenewalInvoiceErrorPayload,
  IRenewalInvoiceStatusPayload,
  RenewalInvoiceRequest,
} from "./types";

export const fetchRenewalInvoiceStatus = (
  payload: RenewalInvoiceRequest,
): ActionTypes => {
  return {
    type: FETCH_RENEWAL_INVOICE_STATUS,
    payload,
  };
};

export const fetchRenewalInvoiceStatusSuccess = (
  payload: IRenewalInvoiceStatusPayload,
): ActionTypes => {
  return {
    type: FETCH_RENEWAL_INVOICE_STATUS_SUCCESS,
    payload,
  };
};

export const fetchRenewalInvoiceStatusError = (
  payload: IRenewalInvoiceErrorPayload,
): ActionTypes => {
  return {
    type: FETCH_RENEWAL_INVOICE_STATUS_ERROR,
    payload,
  };
};

export const createRenewalInvoice = (
  payload: RenewalInvoiceRequest,
): ActionTypes => {
  return {
    type: CREATE_RENEWAL_INVOICE,
    payload,
  };
};

export const createRenewalInvoiceSuccess = (
  payload: IRenewalInvoiceCreatedPayload,
): ActionTypes => {
  return {
    type: CREATE_RENEWAL_INVOICE_SUCCESS,
    payload,
  };
};

export const createRenewalInvoiceError = (
  payload: IRenewalInvoiceErrorPayload,
): ActionTypes => {
  return {
    type: CREATE_RENEWAL_INVOICE_ERROR,
    payload,
  };
};
